'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shortcuts = require('./shortcuts');

var _shortcuts2 = _interopRequireDefault(_shortcuts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  shortcuts: _shortcuts2.default
};